import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const GQL = (props: Props) =>
  gql(`
  query Layers($fieldId: ID!, $filter: FieldDocumentFilter, $sort: DocumentSort, $first: Int) {
    field(id: $fieldId) {
      id
      status {
        ready
        progress
      }
      library(filter: $filter, sort: $sort, first: $first) {
        nodes {
          id
          kind
          thumbnailUrl
          capturedOn
          ... on RasterDocument {
            rasterUrl
            sceneSource
            meanNdvi
            bins {
              max
              min
              color
            }
            geometry {
              type
              coordinates
            }
          }
          ... on YieldAnalysisDocument {
            rasterUrl
          }
          ... on ZoneAnalysisDocument {
            rasterUrl
          }
        }
      }
    }
  }
`);

interface Renders {
  status: FieldStatus | null;
  layers: RasterDocument[] | null;
  loading: boolean;
  refetch: () => void;
}

interface Props {
  farmId: string | null;
  fieldId: string | null;
  kind?: string[] | null;
  sort?: string | null;
  first?: number | null;
  criticalMonths?: number[] | null;
  capturedUntil?: number | null;
  capturedSince?: number | null;
  minMeanNdvi?: number | null;
  maxMeanNdvi?: number | null;
  pollInterval?: number;
  children: (renders: Renders) => React.ReactNode;
}

function mapPropsToVariables(props: Props) {
  return {
    farmId: props.farmId,
    fieldId: props.fieldId,
    filter: {
      kind: props.kind,
      criticalMonths: props.criticalMonths || undefined,
      capturedUntil: props.capturedUntil || undefined,
      capturedSince: props.capturedSince || undefined,
      minMeanNdvi: props.minMeanNdvi || undefined,
      maxMeanNdvi: props.maxMeanNdvi || undefined
    },
    sort: props.sort,
    first: props.first
  };
}

const LayersProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery
    query={GQL(props)}
    skip={!props.farmId || !props.fieldId}
    variables={mapPropsToVariables(props)}
    pollInterval={props.pollInterval}
  >
    {({ data, loading, refetch }) => {
      return props.children({
        status: data && data.field && data.field.status,
        layers: data && data.field && data.field.library && data.field.library.nodes,
        loading: (props.farmId && props.fieldId && loading) || false,
        refetch
      });
    }}
  </AuthorizedQuery>
);

export default LayersProvider;



// WEBPACK FOOTER //
// ./src/providers/LayersProvider.tsx